import React from "react";
import { cn } from "@/lib/utils";

export const PageContainer = ({ children, className }) => {
  return (
    <div
      className={cn(
        "p-4 md:p-6 lg:p-8 w-full max-w-full overflow-x-hidden animate-in fade-in duration-500",
        className,
      )}
    >
      {children}
    </div>
  );
};
